<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Renovação com Valor Incorreto"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getRenewalWrongPrice"
  emptyMessage="Sem mais renovações com valor incorreto no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
